import { render } from "./PortabilityRequestsListView.vue?vue&type=template&id=35539489"
import script from "./PortabilityRequestsListView.vue?vue&type=script&lang=js"
export * from "./PortabilityRequestsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__